<template>
  <g id="MDC">
    <path class="st0" d="M15.5,1.8c-1.1,0-2,0.9-2,2v13h4v-13C17.5,2.7,16.6,1.8,15.5,1.8z" style="fill:#C7C7C7;stroke:#FFFFFF;stroke-linejoin:round;"/>
    <path class="st0" d="M24.5,1.8c-1.1,0-2,0.9-2,2v13h4v-13C26.5,2.7,25.6,1.8,24.5,1.8z" style="fill:#C7C7C7;stroke:#FFFFFF;stroke-linejoin:round;"/>
    <g>
      <path d="M10.7,78.3V64.7L8,62.3l0,0V25.5H6.2v18.2c-0.5,0.4-0.9,0.8-0.9,1.2c0,0.3,0.5,0.8,0.9,1.2v27H1.7v16.3l7,10.7h0.2v0.3
        l5.2,8h8.4l6.2-4.2V78.3H10.7z" />
    </g>
    <g>
      <polygon :fill="color" points="11.2,77.8 11.2,64.3 8.3,62 8.3,56.8 32.1,56.8 32.1,62 29.2,64.2 29.2,77.8 		"/>
      <path fill="#ffffff" d="M28.7,57.3L28.7,57.3h1h1.8v4.4L29,63.6L28.7,64v0.5v12.9h-17V64.6v-0.5l-0.4-0.3l-2.6-2v-4.4h1.9h1
        L28.7,57.3 M29.7,56.3h-19l0,0H7.8v5.9l2.9,2.3v13.7h19V64.4l2.8-2.2v-5.9H29.7L29.7,56.3L29.7,56.3z"/>
    </g>
    <g>
      <polygon :fill="color" points="11.2,56.8 10.7,56.8 8.3,56.8 8.3,19.8 11.2,19.8 11.2,9.8 29.2,9.8 29.2,19.8 32,19.8 32,56.8 		"/>
      <path fill="#ffffff" d="M28.7,10.3v9v1h1h1.7v36h-1.7h-1.1H11.7l0,0h-1h-2v-36h2h1v-1v-9L28.7,10.3 M29.7,9.3h-19v10h-3v38h3l0,0
        h17.9h1.1h2.7v-38h-2.7V9.3L29.7,9.3z"/>
    </g>
    <rect x="18.5" y="43.8" :fill="color" style="stroke:#FFFFFF;stroke-linejoin:round;" width="2.5" height="2"/>
    <rect x="17.5" y="48.8" :fill="color" style="stroke:#FFFFFF;stroke-linejoin:round;" width="4.5" height="2"/>
    <rect x="15.2" y="71.4" style="fill:none;stroke:#FFFFFF;stroke-linejoin:round;" width="8.9" height="6.4"/>
    <rect x="8.2" y="80.8" style="display:none;stroke:#FFFFFF;stroke-linejoin:round;" width="20.1" height="7"/>
    <rect x="15.2" y="71.8" style="fill:none;stroke:#FFFFFF;stroke-linejoin:round;" width="8.9" height="37"/>
    <circle style="fill:none;stroke:#FFFFFF;stroke-linejoin:round;" cx="19.6" cy="104.8" r="2"/>
    <g>
      <path d="M2.8,58.3v3.9c-0.6,0.4-1.4,1-1.4,1.4c0,0.4,0.8,1,1.4,1.4v10h3.9V55.3L2.8,58.3z"/>
    </g>
    <rect x="17.7" y="19.8" :fill="color" style="stroke:#FFFFFF;stroke-linejoin:round;" width="4" height="8"/>
  </g>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MDCPlug",
  props: {
    plugColor: String,
    x: Number,
    y: Number,
    flip: Boolean,
    clip: Boolean,
  },
  data() {
    return {
      plugWidth: 30,
      plugHeight: 10,
    };
  },
  computed: {
    color() {
      return this.getColor(this.plugColor);
    },
    yRecalculated() {
      return this.y - this.plugHeight / 2;
    },
    ...mapGetters(["getCssColor"]),
  },
  methods: {
    getColor(colorName) {
      return this.getCssColor(colorName);
    },
    getNoseColor(colorName) {
      return this.getCssColor(colorName + "Nase");
    },
  },
};
</script>